import React, { Component } from "react";
import { Jumbotron, Carousel, Button, Grid } from "react-bootstrap";
import { Link } from 'react-router-dom';
import './Home.css';

export default class Home extends Component {
  constructor(props) {
  	super(props);
  	this.state = {
  	  isLoading: true
  	};
  }
  render() {
    return (
      <div className="Home">
        <Jumbotron>
          <Grid>
            <Carousel>
              <Carousel.Item>
                <img alt="Portal Condominio" src="/images/carousel1.jpg" />
                <Carousel.Caption>
                  <h3>&iquest;Necesitas solución para administrar tu comunidad?</h3>
                  <p><Button bsStyle="success"><Link to="/services">Nuestros Servicios</Link></Button></p>
                </Carousel.Caption>
              </Carousel.Item>
              <Carousel.Item>
                <img alt="Portal Condominio" src="/images/carousel2.jpg" />
                <Carousel.Caption>
                  <h3>&iquest;Quieres saber m&aacute;s de nosotros?</h3>
                  <p><Button bsStyle="primary"><Link to="/about">Consultar</Link></Button></p>
                </Carousel.Caption>
              </Carousel.Item>
              <Carousel.Item>
                <img alt="Portal Condominio" src="/images/carousel3.jpg" />
                <Carousel.Caption>
                  <h3>&iquest;Tienes alguna duda?</h3>
                  <p className="extra">Comun&iacute;cate con nosotros!</p>
                  <p><Button bsStyle="success"><Link to="/contact">Cont&aacute;ctanos</Link></Button></p>
                </Carousel.Caption>
              </Carousel.Item>
            </Carousel>
          </Grid>
        </Jumbotron>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Home.js